import React from 'react'

const Topbar = () => {
  return (
    <nav>
      <div className="container">
        <span>Sorting Algorithms Visualizer</span>
        <a href="https://github.com/santiagogarcia97/sorting-visualizer-react">
          <img src="github.png" alt="github" />
        </a>
      </div>
    </nav>
  )
}

export default Topbar
